import { Component } from '@angular/core';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.scss'],
  host: {
    id: 'main-container',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[class.content-container]': 'true',
  },
  standalone: false,
})
export class LandingPageComponent {}
